var map = {
	"./AI-Dashboard1.png": 4124,
	"./AI-Dashboard2.png": 4759,
	"./collage-1.jpg": 9611,
	"./collage-2.jpg": 2636,
	"./collage-3.jpg": 4249,
	"./collage-4.jpg": 7786,
	"./collage-5.jpg": 8951,
	"./collage-6.jpg": 8024,
	"./collage-7.png": 9461,
	"./collage-8.png": 306,
	"./venue-decoration.jpg": 6872,
	"./wedding-event.jpg": 2669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4517;